import { useMemo, useState } from "react";
import { connect } from "react-redux";
import slugify from "slugify";
import Grid from "../../../../../../components/Grid";
import CardAticle from "../../../components/CardArticle";
import PostCardSkeleton from "../../../components/PostCardSkeleton";
import { Group } from "../../../../../../types";
import { Post } from "../../../../../../types/post";
import { SectionTitle, SectionDescription } from "../../styles";
import Carousel from "../../../../../../components/Carousel";
import { CardsGrid, Card, Center } from "./styles";
import { useWindowSize } from "../../../../../../hooks/useWindowSize";

interface ComponentProps {
  group: Group;
  groupStates: {
    loading: boolean;
    success: boolean;
    error: string | boolean;
  };
  scheduledPosts: { pagination: { total: number }, data: Post[] };
  scheduledPostsStates: {
    loading: boolean;
    success: boolean;
    error: string | boolean;
  };
}

const Component = ({
  group,
  scheduledPosts,
  scheduledPostsStates,
}: ComponentProps) => {
  const { isMobile } = useWindowSize()
  const [idArticleToDelete, setIdArticleToDelete] = useState(null);

  const shouldShowScheduled = useMemo(() => {
    const isLoading = scheduledPostsStates.loading;
    const hasData = scheduledPosts?.data?.length > 0;
    const hasError = !!scheduledPostsStates.error;

    return (hasData || hasError) && !isLoading
  }, [scheduledPosts, scheduledPosts?.data, scheduledPostsStates]);

  if (!group || group?.group_type === "community" || !shouldShowScheduled) {
    return <></>
  }

  return (
    <>
      <Grid.Container>
        <Grid.Row>
          <Grid.Col>
            <Card>
              <Center horizontal="left" vertical="top" column style={{ padding: isMobile ? '0px 12px' : '0px 32px' }}>
                <Center horizontal="space" vertical="center">
                  <SectionTitle>Artículos programados</SectionTitle>
                </Center>

                <div style={{ height: isMobile ? 8 : 20 }} />

                <SectionDescription>Estos artículos están programados para publicarse en un momento exacto en el futuro.<br />Tus suscriptores no podrán acceder al contenido hasta que estén publicados.</SectionDescription>
              </Center>

              <div style={{ height: isMobile ? 26 : 50 }} />

              {scheduledPostsStates.loading && (
                <CardsGrid>
                  <PostCardSkeleton />
                  <PostCardSkeleton />
                  <PostCardSkeleton />
                </CardsGrid>
              )}

              <Carousel
                items={scheduledPosts?.data}
                renderItem={(post: Post, index: number) => (
                  <CardAticle
                    key={slugify(post.title + index, {
                      lower: true,
                    })}
                    post={post}
                    onDelete={(idPost) =>
                      setIdArticleToDelete(idPost)
                    }
                    groupInformation={group}
                  //blockedPost={!post?.user_access_data?.is_unlocked}
                  />
                )}
                slidesToShow={4}
                scrollAmount={250}
                animationSpeed={400}
                showArrows={scheduledPosts?.data?.length >= 4}
                cardWidth="290px"
                style={{
                  padding: isMobile ? "0px 10px 10px 12px" : "0px 10px 10px 32px",
                  scrollPadding: isMobile ? "0px 10px 0px 12px" : "0px 10px 0px 32px"
                }}
              />
            </Card>
          </Grid.Col>
        </Grid.Row>
      </Grid.Container>

      <div style={{ height: 46 }} />
    </>
  )
};

const state = ({ groupStore, postStore }) => {
  const { data: group, states: groupStates } = groupStore.group;
  const { data: scheduledPosts, states: scheduledPostsStates } = postStore.scheduledPosts;

  return {
    group,
    groupStates,
    scheduledPosts,
    scheduledPostsStates
  };
};

export default connect(state)(Component);
